var _this = this;
var __jsx = React.createElement;
import React, { useEffect, useRef, useState } from "react";
import { addSwipeEvents } from "../../../../utils/GlobalJavascriptFunction";
import classes from "./AffSection3.module.css";
import { useTranslation } from "@i18n";
var AffSection3 = function AffSection3() {
  var _useTranslation = useTranslation(["web_affiliate_program", "web_common"]),
    t = _useTranslation.t,
    tLong = _useTranslation.tLong;
  var _useState = useState(0),
    activeImageIndex = _useState[0],
    setActiveImageIndex = _useState[1];
  var someAffDataContainerRef = useRef();
  var setNewBox = function setNewBox(index) {
    setActiveImageIndex(index);
  };
  var data = [{
    id: 1,
    imgSrc: "/assets/bundles/af1.svg",
    title: t("earn_attractive_commissions", {
      ns: "web_affiliate_program"
    }),
    description: tLong("affiliate/commission-per-sale", {
      ns: "web_affiliate_program"
    })
  }, {
    id: 2,
    imgSrc: "/assets/bundles/af2.svg",
    title: t("biggest_car_market_arab_world", {
      ns: "web_affiliate_program"
    }),
    description: tLong("affiliate/saudi-market-size", {
      ns: "web_affiliate_program"
    })
  }, {
    id: 3,
    imgSrc: "/assets/bundles/af3.svg",
    title: t("get_commissions_directly", {
      ns: "web_affiliate_program"
    }),
    description: tLong("affiliate/monthly-commission-payment", {
      ns: "web_affiliate_program"
    })
  }, {
    id: 4,
    imgSrc: "/assets/bundles/af4.svg",
    title: t("get_exclusive_discount_coupons", {
      ns: "web_affiliate_program"
    }),
    description: tLong("affiliate/discount-coupons", {
      ns: "web_affiliate_program"
    })
  }, {
    id: 5,
    imgSrc: "/assets/bundles/af5.svg",
    title: t("free_marketing_resources", {
      ns: "web_affiliate_program"
    }),
    description: tLong("affiliate/marketing-resources", {
      ns: "web_affiliate_program"
    })
  }];
  useEffect(function () {
    if (activeImageIndex === 0) return;
    /*    if (window.innerWidth > 1024) return;
        let relativePosleft =
          someAffDataContainerRef.current
            .querySelector(".readMe")
            ?.getBoundingClientRect()?.left -
          someAffDataContainerRef.current?.getBoundingClientRect()?.left;
    
        someAffDataContainerRef.current.style.transform =
          "translate(" + -1 * relativePosleft + "px, 0)";*/
  }, [activeImageIndex]);
  useEffect(function () {
    addSwipeEvents(someAffDataContainerRef.current, function () {
      activeImageIndex > 0 && setNewBox(_this.state.activeImageIndex - 1);
    }, function () {
      activeImageIndex < data.length - 1 && setNewBox(activeImageIndex + 1);
    });
  }, []);
  return /*#__PURE__*/React.createElement("section", {
    className: classes.AffiliateSection3
  }, /*#__PURE__*/React.createElement("div", {
    className: ["container", classes.containerMaxWidth].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.whyAffiliateUs
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", null, t("why_promote", {
    ns: "web_affiliate_program"
  }), " ", /*#__PURE__*/React.createElement("br", {
    className: "m-hide"
  }), t("cars", {
    ns: "web_affiliate_program"
  }), " ", /*#__PURE__*/React.createElement("br", {
    className: "m-show"
  }), t("syarah", {
    ns: "web_affiliate_program"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://syarah.trackier.com/register.html",
    className: ["redBtn", "m-hide", classes.mrkALink].join(" ")
  }, t("start_earning_today", {
    ns: "web_affiliate_program"
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: classes.someAffDataContainer,
    ref: someAffDataContainerRef
  }, data.map(function (item, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: item.id,
      onClick: function onClick() {
        setNewBox(i);
      },
      className: "".concat(classes.singleAffWhy, " ").concat(activeImageIndex === i ? "readMe activeHow" : "")
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
      loading: "lazy",
      src: item.imgSrc,
      alt: item.title
    })), /*#__PURE__*/React.createElement("h3", null, item.title), /*#__PURE__*/React.createElement("p", null, item.description));
  }))), /*#__PURE__*/React.createElement("a", {
    href: "https://syarah.trackier.com/register.html",
    className: ["redBtn", classes.mrkALink, "m-show"].join(" ")
  }, t("start_earning_today", {
    ns: "web_affiliate_program"
  })))));
};
export default AffSection3;